module.exports = __webpack_public_path__ + "static/media/enjoyment.1a6c2233.svg";